export default __webpack_public_path__ + "media/titles/title_3_locale_nl-34f6487c.png";